/**
     * contracts/index.ts — registers every event contract with the platform
     * registry. Called once during bootstrap; arming the registry activates
     * publish-time validation on the Core Event Bus.
     */

    import { eventContractRegistry } from '../EventContractRegistry';
    import { LocationChangedContract } from './LocationChanged.contract';
import { WeatherUpdatedContract } from './WeatherUpdated.contract';
import { CurrencyUpdatedContract } from './CurrencyUpdated.contract';
import { HousingUpdatedContract } from './HousingUpdated.contract';
import { PlacesUpdatedContract } from './PlacesUpdated.contract';
import { EventsUpdatedContract } from './EventsUpdated.contract';
import { SafetyUpdatedContract } from './SafetyUpdated.contract';
import { CommunityUpdatedContract } from './CommunityUpdated.contract';
import { MissionCreatedContract } from './MissionCreated.contract';
import { MissionCompletedContract } from './MissionCompleted.contract';
import { PaymentReceivedContract } from './PaymentReceived.contract';
import { JourneyUpdatedContract } from './JourneyUpdated.contract';
import { RoamerScoreUpdatedContract } from './RoamerScoreUpdated.contract';
import { PhotoUploadedContract } from './PhotoUploaded.contract';
import { HeaderChangedContract } from './HeaderChanged.contract';
import { NotificationSentContract } from './NotificationSent.contract';
import { EngineRegisteredContract } from './EngineRegistered.contract';
import { EngineStatusChangedContract } from './EngineStatusChanged.contract';
import { SystemStateChangedContract } from './SystemStateChanged.contract';
import { DataSynchronizedContract } from './DataSynchronized.contract';
import { PersistenceFailedContract } from './PersistenceFailed.contract';
import { WorkflowCompletedContract } from './WorkflowCompleted.contract';
import { CareerUpdatedContract } from './CareerUpdated.contract';
import { IncomeRecordedContract } from './IncomeRecorded.contract';
import { IncomeUpdatedContract } from './IncomeUpdated.contract';
import { CompanyAddedContract } from './CompanyAdded.contract';
import { CompanyUpdatedContract } from './CompanyUpdated.contract';
import { OperatorSignedInContract } from './OperatorSignedIn.contract';
import { OperatorHydratedContract } from './OperatorHydrated.contract';
import { CloudHydrationCompletedContract } from './CloudHydrationCompleted.contract';
import { OperatorSignedOutContract } from './OperatorSignedOut.contract';
import { SessionRestoredContract } from './SessionRestored.contract';
import { SessionExpiredContract } from './SessionExpired.contract';

    export const ALL_EVENT_CONTRACTS = [
      LocationChangedContract,
  WeatherUpdatedContract,
  CurrencyUpdatedContract,
  HousingUpdatedContract,
  PlacesUpdatedContract,
  EventsUpdatedContract,
  SafetyUpdatedContract,
  CommunityUpdatedContract,
  MissionCreatedContract,
  MissionCompletedContract,
  PaymentReceivedContract,
  JourneyUpdatedContract,
  RoamerScoreUpdatedContract,
  PhotoUploadedContract,
  HeaderChangedContract,
  NotificationSentContract,
  EngineRegisteredContract,
  EngineStatusChangedContract,
  SystemStateChangedContract,
  DataSynchronizedContract,
  PersistenceFailedContract,
  WorkflowCompletedContract,
  CareerUpdatedContract,
  IncomeRecordedContract,
  IncomeUpdatedContract,
  CompanyAddedContract,
  CompanyUpdatedContract,
  OperatorSignedInContract,
  OperatorSignedOutContract,
  SessionRestoredContract,
  SessionExpiredContract,
  OperatorHydratedContract,
  CloudHydrationCompletedContract,
    ] as const;

    let registered = false;

    /** Idempotent — safe to call from bootstrap and tests. */
    export function registerAllEventContracts(): void {
      if (registered) return;
      for (const contract of ALL_EVENT_CONTRACTS) eventContractRegistry.register(contract);
      registered = true;
    }
    